import { useEffect, useState } from 'react';
export function useWidth(mobileBreakPoint = 767) {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= mobileBreakPoint
  );

  useEffect(() => {
    const handleResize = () => {
      if (window.visualViewport) {
        if (window.visualViewport.width <= mobileBreakPoint) {
          setIsMobile(true);
        } else {
          setIsMobile(false);
        }
      } else {
        if (window.innerWidth <= mobileBreakPoint) {
          setIsMobile(true);
        } else {
          setIsMobile(false);
        }
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
}
